import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@bingads-webui-react/alert';

export class DraftAlert extends React.PureComponent {
  render() {
    const {
      hasDraftStore, i18n, isNewUII18n, scope, onLinkClick,
    } = this.props;

    const { aid, cid, uid } = scope.values;

    const href = `merchantcenter?aid=${aid}&cid=${cid}&uid=${uid}`;
    const linkProps = !onLinkClick ?
      { href, target: '_blank', rel: 'noopener noreferrer' } :
      { href, onClick: onLinkClick };

    return (
      <div className="draft-store-alert">
        {hasDraftStore ?
          <Alert
            dismissible={false}
            icon={(<div className="alert-image" />)}
            level="Info"
            message={(
              <div>
                {isNewUII18n ? i18n.getString(_TL_('Shopping campaigns with a draft store will not run. You will need to ')) :
                  i18n.getString('Draft_Alert_Text_Part_1')}
                {
                  <a {...linkProps}>
                    {isNewUII18n ? i18n.getString(_TL_('complete Microsoft Merchant Center store set up.')) :
                      i18n.getString('Draft_Alert_Text_Part_2')}
                  </a>
                }
              </div>)}
          />
          : null
        }
      </div>
    );
  }
}

DraftAlert.propTypes = {
  hasDraftStore: PropTypes.bool.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  isNewUII18n: PropTypes.bool,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      aid: PropTypes.number.isRequired,
      cid: PropTypes.number.isRequired,
      uid: PropTypes.number.isRequired,
    }).isRequired,
  }).isRequired,
  onLinkClick: PropTypes.func,
};

DraftAlert.defaultProps = {
  isNewUII18n: true,
  onLinkClick: undefined,
};
